module.exports = __webpack_public_path__ + "img/phone.5cac48f2.svg";